import { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { subjectLineGeneration } from "screens/Campaigns/CampaignService";
import ReplayIcon from "@mui/icons-material/Replay";
import { copyTextHandler, handleErrorMessage } from "helpers/methods";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CustomProps {
  exportPlainText: Function;
  exportHTML: Function;
}

const SubjectLineHelper = (props: CustomProps) => {
  const [subjectLines, setSubjectLines] = useState<string[]>([]);
  const [reRun, setReRun] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const checkIfContentsNonEmpty = (body: any) => {
    return body?.rows?.some((row: any) =>
      row?.columns?.some((column: any) => column?.contents?.length > 0)
    );
  };

  const generateSubjectLines = async () => {
    try {
      setLoading(true);
      const content = await props.exportHTML();
      const {
        html,
        design: { body },
      } = content;
      const isEmpty = !checkIfContentsNonEmpty(body);
      if (!isEmpty) {
        const aiResponse = await subjectLineGeneration(html);
        setSubjectLines(aiResponse.subject);
      }
      setReRun(true);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleErrorMessage(error);
    }
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="h6">Subject Line Helper</Typography>
        <Typography variant="body2">
          Subject Line Helper analyzes your email body to craft compelling
          subject lines that grab attention and increase open rates.
        </Typography>
      </Stack>
      {loading ? (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="100%" height={40} />
          <Skeleton variant="rounded" width="100%" height={40} />
          <Skeleton variant="rounded" width="100%" height={40} />
        </Stack>
      ) : subjectLines.length > 0 ? (
        <Stack spacing={1}>
          {subjectLines.map((subjectLine, index) => (
            <Stack
              key={index}
              sx={{
                border: "1px solid #7551D0",
                p: 1,
                borderRadius: "12px",
                cursor: "pointer",
              }}
              direction="row"
            >
              <Typography>{subjectLine}</Typography>
              <IconButton onClick={() => copyTextHandler(subjectLine)}>
                <SvgIcon fontSize="small">
                  <ContentCopyIcon fontSize="small" />
                </SvgIcon>
              </IconButton>
            </Stack>
          ))}
        </Stack>
      ) : null}
      {reRun ? (
        <Box>
          <IconButton
            sx={{ border: "1px solid #7551D0" }}
            onClick={generateSubjectLines}
            disabled={loading}
          >
            <SvgIcon>
              <ReplayIcon htmlColor="#7551D0" />
            </SvgIcon>
          </IconButton>
        </Box>
      ) : (
        <Button
          variant="contained"
          size="small"
          disabled={loading}
          onClick={generateSubjectLines}
        >
          Generate Subject Lines
        </Button>
      )}
    </Stack>
  );
};

export default SubjectLineHelper;
